/* eslint-disable import/prefer-default-export */
import logToConsole from '../../Utils/logToConsole';

const getTelemetryUrl = () =>
  `${process.env.NEXT_PUBLIC_CHAMELEON_GATEWAY_BASE_URL}/telemetry`;

const toBody = ({ name, tags = {} }, transport) =>
  JSON.stringify({ name, tags, transport });

const logSendFailure = (error) =>
  logToConsole.info(
    'MVF App Info - Failed to send telemetry to the gateway:',
    error?.message || error
  );

/**
 * Queues the event with navigator.sendBeacon, which survives page unload.
 * The string body is sent as text/plain, so no CORS preflight is needed.
 * @returns {boolean} false when the browser can't or won't queue the beacon
 */
const sendWithBeacon = (url, event) => {
  if (typeof navigator === 'undefined') return false;
  if (typeof navigator.sendBeacon !== 'function') return false;

  try {
    return navigator.sendBeacon(url, toBody(event, 'beacon'));
  } catch (error) {
    logSendFailure(error);
    return false;
  }
};

/**
 * Not retried: a 429 would only add load, and a 4xx won't change on retry.
 * The gateway's own telemetry.rejected / rate_limited counters record losses.
 */
const sendWithFetch = (url, event) => {
  fetch(url, {
    method: 'POST',
    body: toBody(event, 'fetch'),
    keepalive: true,
  })
    .then((response) => {
      if (!response.ok) logSendFailure(`status ${response.status}`);
    })
    .catch(logSendFailure);
};

/**
 * Sends a browser metric to chameleon-gateway's POST /telemetry endpoint,
 * which forwards it to Datadog as chameleon_gateway.frontend.<name>.
 * The gateway adds origin_id and drops tags it doesn't allow for the event.
 */
export const incrementMetric = ({ name, tags }) => {
  if (typeof window === 'undefined') return;
  if (process.env.NEXT_PUBLIC_SEND_DD_METRICS !== 'true') {
    return;
  }

  const url = getTelemetryUrl();
  const event = { name, tags };
  if (sendWithBeacon(url, event)) return;

  sendWithFetch(url, event);
};
